















































































import { defineComponent, computed, PropType } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import useSwitchDevice from "@/store/modules/useSwitchDevice";
import { sensor } from "@/store";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        PairToggle: () =>
            import(/*webpackChunkName: "components"*/ "../PairToggle.vue"),
    },
    props: {
        value: Object as PropType<AttachedDeviceModel>,
    },
    setup(props, { emit }) {
        const { turnOn, turnOff } = useSwitchDevice();

        const paired = computed(() =>
            !!(props.value?.attachedDeviceId && props.value.attachedDeviceId !== "")
        );

        const isConnecting = computed(() => props.value?.isConnecting === true);

        const responsive = computed(() =>
            props.value?.attachedDeviceId ? props.value.age < 4 : false
        );

        const switchStatus = computed<boolean>(() => {
            return ((props.value as any)?.status === true);
        });
        const imgSrc = computed(() => require(`@/assets/img/gas-valve.png`));

        const sensorSyncronising = computed(() => !!((props.value as any)?.isBusy || (props.value as any)?.isConnecting));

        const onEnroll = () => {
            if (props.value) emit('enroll', { typeId: props.value.attachedDeviceTypeId, img: imgSrc.value });
        };

        const onUnpair = () => {
            if (props.value) emit('unpair', { deviceId: props.value.attachedDeviceId })
        }

        const switchChange = (next: boolean) => {
            if (!props.value) return;
            // Send command
            if (next) turnOn(props.value.attachedDeviceId);
            else turnOff(props.value.attachedDeviceId);
            // Optimistic UI
            (props.value as any).status = next;
        };

        return {
            onEnroll,
            onUnpair,
            paired,
            imgSrc,
            responsive,
            switchStatus,
            sensorSyncronising,
            switchChange,
            isConnecting,
        };
    },
});
